import Wrapper from 'components/reusables/wrapper'
import ExternalCourse from './components/externalCourse'

const ExternalCourseAdministration: React.FC = () => {
  return (
    <Wrapper shadow={true}>
      <ExternalCourse />
    </Wrapper>
  )
}

export default ExternalCourseAdministration
